import { render } from "./user-control-devices.vue?vue&type=template&id=80242cc0&scoped=true&ts=true"
import script from "./user-control-devices.vue?vue&type=script&lang=ts"
export * from "./user-control-devices.vue?vue&type=script&lang=ts"

import "./user-control-devices.vue?vue&type=style&index=0&id=80242cc0&scoped=true&lang=less"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80242cc0"]])

export default __exports__